import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const CampaignSchedule = {
  list: async () => {
    try {
      const response = await apiService.get("/itouch/campaignschedule/list");
      return response.data;
    } catch (error) {
      console.error("Error fetching campaign schedules:", error);
      throw error;
    }
  },

  update: async (id, data) => {
    /**
     * Example of data object:
     * {
     *   campaignId: 55,
     *   startDate: "2026-03-06T08:39:11.602Z",
     *   endDate: "2026-03-06T08:39:11.602Z",
     *   sunday: true,
     *   monday: true,
     *   tuesday: true,
     *   wednesday: true,
     *   thursday: true,
     *   friday: true,
     *   saturday: true,
     *   startTime: "10:00:00",
     *   endTime: "21:00:00",
     *   isActive: true
     * }
     */
    try {
      const response = await apiService.put(
        `/itouch/campaignschedule/${id}`,
        data,
      );
      return response.data;
    } catch (error) {
      console.error("Error updating campaign schedule:", error);
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await apiService.delete(
        `/itouch/campaignschedule/${id}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting campaign schedule:", error);
      throw error;
    }
  },

  assignToCampaigns: async (data) => {
    /**
     * Example of data object:
     * {
     *   campaignIds: [1, 2],
     *   startDate: "2026-03-06T06:59:00.733Z",
     *   endDate: "2026-03-06T06:59:00.733Z",
     *   sunday: true,
     *   monday: true,
     *   tuesday: true,
     *   wednesday: true,
     *   thursday: true,
     *   friday: true,
     *   saturday: true,
     *   startTime: "10:00:00",
     *   endTime: "21:00:00"
     * }
     */
    try {
      const response = await apiService.post(
        "/itouch/campaignschedule/assign-to-campaigns",
        data,
      );
      return response.data;
    } catch (error) {
      console.error("Error assigning campaigns to schedule:", error);
      throw error;
    }
  },

  campaignCalendar: async () => {
    try {
      const response = await apiService.get(
        "/itouch/campaignschedule/calendar",
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching campaign calendar:", error);
      throw error;
    }
  },
};

export default CampaignSchedule;
